import { useEffect, useRef, useState } from 'react'
import copyfallback from 'copy-to-clipboard'

//Cannot do lazy loading until top-level await is supported
// const copyfallback =
//   !isClipboardAPISupported && (await import('copy-to-clipboard'));

interface IOptions {
  /**
   * Reset the status after a certain number of milliseconds. This is useful
   * for showing a temporary success message.
   */
  successDuration: number
}

const defaultOptions: IOptions = {
  successDuration: 2000,
}

export const useClipboard = (
  value: string,
  options: IOptions = defaultOptions
) => {
  const [isCopied, setIsCopied] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    if (isCopied && options.successDuration) {
      timeoutRef.current = setTimeout(() => {
        setIsCopied(false)
      }, options.successDuration)
    }
    return () => {
      // @ts-ignore
      clearTimeout(timeoutRef.current)
    }
  }, [isCopied, options.successDuration])

  const copy = async () => {
    const isClipboardAPISupported = 'clipboard' in (window?.navigator ?? {})
    try {
      if (isClipboardAPISupported) {
        await window.navigator.clipboard.writeText(value)
        setIsCopied(true)
      } else {
        const didCopy = copyfallback && copyfallback(value)
        setIsCopied(didCopy)
      }
    } catch (e) {
      console.log(e)
    }
  }

  return {
    isCopied,
    copy,
  }
}
